import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-payout-details',
  templateUrl: './payout-details.component.html',
  styleUrls: ['./payout-details.component.scss']
})
export class PayoutDetailsComponent implements OnInit {

  _currentComponentName = 'PayoutDetailsComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler) { }

  parentEvent$
  paymentDetailsForm: FormGroup
  PAYMENTDETAILSFORMNAME = "paymentDetailsForm"
  selectorOfThisComponent = 'app-payout-details'

  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;

  private _policyData
  @Input()
  set policyData(value: any) {
    if (value == null || !value)
      this._policyData = {}
    else {
      this._policyData = value
      this.claimSettlementDO = this.getSettlementDO(this._policyData) || {};
    }

  }

  get policyData() {
    return this._policyData;
  }


  claimSettlementDO: any;

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let isOutputValid = true
      if (isOutputValid)
        this.EmitComponentOutput(this.paymentDetailsForm)
      else {
        this.EmitComponentOutput("ERROR")
      }
    })
  }

  permissions = {
    payout_details: { show: true, edit: false },
  };

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.getCurrentComponentName()}></${this.getCurrentComponentName()}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle)
      console.groupEnd();
    }
    this.subscribeToParentEvent()
  }


  initializePaymentDetailsForm(data?) {
    let payload = data || {}
    this.paymentDetailsForm = this.fb.group({

    });
  }


  getSettlementDO(IO) {
    let DO = null
    if (IO) {
      DO = IO['claimDO'] || IO['adjudicationDO'] || IO['investigationDO'];
      if (DO)
        return DO['claimSettlements']
      else
        return null
    }
    else
      null
  }


}
